import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { PimoReactComponent } from "@pimo/pimo-app-builder";

type PhaseSectionsCardProps = {
  phases: {
    count: number;
    phaseName: string;
    phaseColor: string;
    textColor: string;
  }[];
};

export const PhaseSectionsCard: PimoReactComponent<PhaseSectionsCardProps> = (
  props: PhaseSectionsCardProps
) => {
  const { phases } = props;

  return (
    <Box sx={{ display: "flex", flexDirection: "row", minWidth: 300 }}>
      {phases.map((phase, index) => (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0.5,
          }}
          key={index}
        >
          <Box
            key={index}
            sx={{
              backgroundColor: phase.phaseColor,
              color: phase.textColor,
              borderTopLeftRadius: index === 0 ? "6px" : 0,
              borderBottomLeftRadius: index === 0 ? "6px" : 0,
              borderTopRightRadius: index === phases.length - 1 ? "6px" : 0,
              borderBottomRightRadius: index === phases.length - 1 ? "6px" : 0,

              textAlign: "center",
              width: `${phase.count * 0.7 + 20}px`,
              maxWidth: "75px",
              minWidth: "20px",
              fontSize: "12px",
              height: "20px",
              lineHeight: "20px",
            }}
          >
            {phase.count}
          </Box>
          <Typography variant="body2">{phase.phaseName}</Typography>
        </Box>
      ))}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            color: "#414141",

            textAlign: "center",
            width: `50px`,

            fontSize: "12px",
            height: "20px",
            lineHeight: "20px",
          }}
        >
          {phases.reduce((acc, curr) => acc + curr.count, 0)}
        </Box>
        <Typography variant="body2">Total</Typography>
      </Box>
    </Box>
  );
};
